import { IData } from "./DataStructure.js";

export class Data {
    public onComplete = e5.Signal.create<[IData]>();
    public data: IData = null;

    public load(url: string): void {
        var ajax = new XMLHttpRequest();
        ajax.onreadystatechange = (e: Event) => {
            if (ajax.readyState == 4) {
                if (ajax.status == 200) {
                    var response = ajax.response;
                    this.parse(JSON.parse(response) as IData);
                }
                else {
                    // request.state = RequestState.FAILED;
                    // request.onFail.invoke("404");
                    //this.showError("Leider konnten die Video-Daten nicht geladen werden");
                }
            }
            else if (ajax.readyState == 0) {
                console.log("REQUEST NOT INIT");
            }
        }
        ajax.responseType = "text";
        ajax.open("get", url);
        ajax.send();
    }

    private parse(data: IData): void {
        this.data = data;

        for (var stepper of data.stepper) {
            stepper.steps.sort((a, b) => {
                return a.stepper_watt - b.stepper_watt;
            });
        }

        this.onComplete.dispatch(data);
    }
}